<div class="navbar"
    *ngIf="!isDashboardRoute && !isConsumRoute && !isLoginRoute && !isCheckEmailRoute && !isExternalDashboardRoute">

    <div class="logo">
        <img src="assets/logo.png" alt="logo" routerLink="/dashboard"
            [queryParams]="{ type: selectedUserType === 'inbound' ? 'EVIB' : 'EVOB' }"
            (click)="selectNavLink('dashboard')" [ngClass]="{'active-link': isDashboardSelect}">
    </div>

    <ul class="nav-links">
        <li>
            <a routerLink="/dashboard" [queryParams]="{ type: selectedUserType === 'inbound' ? 'EVIB' : 'EVOB' }"
                (click)="selectNavLink('dashboard')" [ngClass]="{'active-link': isDashboardSelect}">
                Home
            </a>
        </li>
        <li *ngIf="canShowControlCenter()">
            <a [routerLink]="selectedUserType === 'inbound' ? '/control-center-inbound' : '/control-center-outbound'"
                [queryParams]="{ type: selectedUserType === 'inbound' ? 'EVIB' : 'EVOB' }"
                (click)="selectNavLink('control-center')" [ngClass]="{'active-link': isControlCenterSelect}">
                Control Center
            </a>
        </li>
        <li *ngIf="canShowMasterData()">
            <a [routerLink]="selectedUserType === 'inbound' ? '/master-data-inbound' : '/master-data-outbound'"
                [queryParams]="{ type: selectedUserType === 'inbound' ? 'EVIB' : 'EVOB' }"
                (click)="selectNavLink('master-data')" [ngClass]="{'active-link': isMasterDataSelects}">
                Master Data
            </a>
        </li>
        <li *ngIf="canShowReport()">
            <a [routerLink]="selectedUserType === 'inbound' ? '/app-report' : '/app-report'"
                [queryParams]="{ type: selectedUserType === 'inbound' ? 'EVIB' : 'EVOB' }"
                (click)="selectNavLink('app-report')" [ngClass]="{'active-link': isReportSelect}">
                Report
            </a>
        </li>
        <li *ngIf="canShowAdminRule()">
            <a [routerLink]="selectedUserType === 'inbound' ? '/administrative-rule-inbound' : '/administrative-rule-outbound'"
                [queryParams]="{ type: selectedUserType === 'inbound' ? 'EVIB' : 'EVOB' }"
                (click)="selectNavLink('administrative-rule')" [ngClass]="{'active-link': isAdministratorRuleSelect}">
                Rule Administration
            </a>
        </li>
    </ul>

    <div class="end-div">
        <div class="inbound-or-outbound">
            <ul class="nav-links custom-end">
                <li class="selected-label-container custom-pd-bk"
                    *ngIf="isActive('/control-center-inbound') || isActive('/control-center-outbound')">
                    <span class="selected-label">
                        {{ isActive('/control-center-inbound') ? 'Inbound' : 'Outbound' }}
                    </span>
                </li>
                <li class="selected-label-container custom-pd-bk"
                    *ngIf="isActive('/app-report')">
                    <span class="selected-label">
                     {{ selectedUserType === 'inbound' ? 'Inbound' : 'Outbound' }}
                    </span>
                </li>
                <li class="selected-label-container custom-pd-bk"
                    *ngIf="isActiveMasterData('/master-data-inbound') || isActiveMasterData('/master-data-outbound')">
                    <span class="selected-label">
                        {{ isActiveMasterData('/master-data-inbound') ? 'Inbound' : 'Outbound' }}
                    </span>
                </li>
                <li class="selected-label-container custom-pd-bk"
                    *ngIf="isActive('/administrative-rule-inbound') || isActive('/administrative-rule-outbound')">
                    <span class="selected-label">
                        {{ isActive('/administrative-rule-inbound') ? 'Inbound' : 'Outbound' }}
                    </span>
                </li>
            </ul>
        </div>

        <div class="navbar-icons" (click)="toggleProfileDropdown()" tabindex="0" (blur)="closeProfileDropdown()">
            <div class="profile-initials">{{ getInitials(userName) }}</div>
            <ul class="profile-dropdown" [class.show]="profileDropdownVisible">
                <li class="profile-name">{{ userName }}</li>
                <li (click)="logout()">Logout</li>
            </ul>
        </div>
    </div>
</div>